export class ApiService {
  constructor() {
    this.myHeaders = new Headers({
      'Content-Type': 'application/json; charset=utf-8',
      'X-RequestDigest': document.getElementById('__REQUESTDIGEST').value,
    });
    this.baseUrl = window.location.origin;
  }

  async post(endpoint, body) {
    const requestOptions = {
      method: 'POST',
      headers: this.myHeaders,
      body: JSON.stringify(body),
    };

    try {
      const response = await fetch(`${this.baseUrl}/_vti_bin/Servicios/${endpoint}`, requestOptions);
      const responseText = await response.text();
      const { result } = JSON.parse(responseText);

      if (!response.ok) {
        throw new Error(`Error ${ResponseCode}: ${result}`);
      }

      if (!!result) return { result };
      return JSON.parse(responseText);
    } catch (error) {
      throw error;
    }
  }
}
